import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { forwardRef, useEffect, useState } from 'react'
import { CheckCircleFill, DashCircleFill, PlusCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'

import { CustomPriceInput } from '../../../components/CustomPriceInput'
import { CustomButton } from '../../../components/CustomButton'
import PessoasService from '../../../services/database/PessoasService'

import './styles.css'

export const ModalModificarSaldo = forwardRef(
  ({ isOpen, pessoa, onClose, loadPessoas }, ref) => {
    const [operationType, setOperationType] = useState('entrada')
    const [isLoading, setIsLoading] = useState(false)
    const [value, setValue] = useState('')

    const isEntrada = operationType === 'entrada'

    async function handleUpdateBalance() {
      try {
        setIsLoading(true)
        await PessoasService.updateBalance({
          codPessoa: pessoa.cod_pessoa,
          type: operationType,
          value,
        })
        toast.success('Saldo atualizado com sucesso!')
        onClose()
        loadPessoas()
      } catch (error) {
        console.error(error)
        toast.error('Erro ao atualizar saldo, tente novamente mais tarde!')
      } finally {
        setIsLoading(false)
      }
    }

    useEffect(() => {
      if (isOpen) {
        setOperationType('entrada')
        setIsLoading(false)
        setValue('')
      }
    }, [isOpen])

    return (
      <Modal
        ref={ref}
        show={isOpen}
        onHide={onClose}
        centered
        dialogClassName="modal-modificar-saldo-dialog"
      >
        {/* Header */}
        <Modal.Header
          closeButton
          style={{ borderBottom: '1px solid #e8e8e8', padding: '1rem 1.25rem' }}
        >
          <div>
            <Modal.Title style={{ fontSize: 16, fontWeight: 600, marginBottom: 2 }}>
              Modificar saldo
            </Modal.Title>
            <p style={{ fontSize: 12, color: '#888', margin: 0 }}>
              Cliente:{' '}
              <strong style={{ color: '#185FA5', fontWeight: 600 }}>
                {pessoa?.pes_razao}
              </strong>
            </p>
          </div>
        </Modal.Header>

        {/* Body */}
        <Modal.Body style={{ padding: '1.25rem' }}>

          {/* Tipo de operação */}
          <p style={{ fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>
            Tipo de operação
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: '1.5rem' }}>
            {/* Entrada */}
            <button
              onClick={() => setOperationType('entrada')}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 8,
                padding: '16px 12px',
                borderRadius: 10,
                border: `2px solid ${isEntrada ? '#3B6D11' : '#e8e8e8'}`,
                background: isEntrada ? '#EAF3DE' : '#fafafa',
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
            >
              <PlusCircleFill
                size={28}
                color={isEntrada ? '#3B6D11' : '#bbb'}
              />
              <span style={{ fontSize: 13, fontWeight: 600, color: isEntrada ? '#3B6D11' : '#aaa' }}>
                Adicionar saldo
              </span>
              <span style={{ fontSize: 11, color: isEntrada ? '#5A9A20' : '#bbb' }}>
                Acréscimo ao cliente
              </span>
            </button>

            {/* Saída */}
            <button
              onClick={() => setOperationType('saida')}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 8,
                padding: '16px 12px',
                borderRadius: 10,
                border: `2px solid ${!isEntrada ? '#A32D2D' : '#e8e8e8'}`,
                background: !isEntrada ? '#FCEBEB' : '#fafafa',
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
            >
              <DashCircleFill
                size={28}
                color={!isEntrada ? '#A32D2D' : '#bbb'}
              />
              <span style={{ fontSize: 13, fontWeight: 600, color: !isEntrada ? '#A32D2D' : '#aaa' }}>
                Remover saldo
              </span>
              <span style={{ fontSize: 11, color: !isEntrada ? '#C94444' : '#bbb' }}>
                Débito do cliente
              </span>
            </button>
          </div>

          {/* Valor */}
          <p style={{ fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
            Valor
          </p>

          <CustomPriceInput
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="R$ 0,00"
            style={{ width: '100%', fontSize: 15 }}
          />

          {/* Preview da operação */}
          {value && (
            <div style={{
              marginTop: '1rem',
              padding: '10px 14px',
              borderRadius: 8,
              background: isEntrada ? '#EAF3DE' : '#FCEBEB',
              border: `1px solid ${isEntrada ? '#C0DD97' : '#F7C1C1'}`,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 13,
              color: isEntrada ? '#3B6D11' : '#A32D2D',
            }}>
              {isEntrada
                ? <PlusCircleFill size={15} />
                : <DashCircleFill size={15} />
              }
              <span>
                {isEntrada ? 'Será adicionado ' : 'Será removido '}
                <strong>{value}</strong>
                {isEntrada ? ' ao saldo do cliente' : ' do saldo do cliente'}
              </span>
            </div>
          )}
        </Modal.Body>

        {/* Footer */}
        <Modal.Footer style={{ borderTop: '1px solid #e8e8e8', padding: '0.75rem 1.25rem', gap: 8 }}>
          <button
            onClick={onClose}
            style={{
              padding: '7px 16px',
              fontSize: 13,
              borderRadius: 6,
              border: '1px solid #dee2e6',
              background: '#fff',
              color: '#555',
              cursor: 'pointer',
            }}
          >
            Cancelar
          </button>

          <CustomButton
            isLoading={isLoading}
            isLoadingText="Salvando..."
            onClick={handleUpdateBalance}
            color={isEntrada ? '#3B6D11' : '#A32D2D'}
            isDisabled={!value}
          >
            <CheckCircleFill />
            {isEntrada ? 'Adicionar saldo' : 'Remover saldo'}
          </CustomButton>
        </Modal.Footer>
      </Modal>
    )
  },
)